import axios from 'axios'
import {
  GET_ECG_REPORT_FILE,
  GET_IPD_ECG_REPORTS,
  GET_OPD_ECG_REPORT,
  UPLOAD_ECG_REPORT,
} from '../utils/Endpoints'

const headers = {
  headers: {
    'api-key': process.env.REACT_APP_TRICOG_API_KEY ?? '',
  },
}

export const postEcgReport = async (
  file: File | any,
  type: string,
  name: string,
  role: string,
  interpretation?: string,
  patientMuhId?: string,
  visitId?: string
) => {
  try {
    const formData = new FormData()

    formData.append('file', file)
    formData.append('type', type)
    formData.append('name', name)
    formData.append('role', role)
    if (interpretation) {
      formData.append('interpretation', interpretation)
    }
    if (patientMuhId) {
      formData.append('patientMuhId', patientMuhId)
    }
    if (visitId) {
      formData.append('visitId', visitId)
    }

    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${UPLOAD_ECG_REPORT}`,
      formData,
      headers
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getIpdEcgReports = async (patientMuhId: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_IPD_ECG_REPORTS}${patientMuhId}?order=asc`,
      headers
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getOpdEcgReport = async (visitId: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_OPD_ECG_REPORT}${visitId}`,
      headers
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}

export const getEcgReportFile = async (fileName: string) => {
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_ECG_REPORT_FILE}${fileName}`,
      {
        headers: {
          ...headers.headers, // spread inside headers
          Accept: 'application/pdf',
        },
        responseType: 'arraybuffer', // fetch raw PDF bytes
      }
    )
    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: 'File fetched Successfully',
      }
    } else {
      return {
        success: false,
        data: null,
        message: 'Failed to fetch file',
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || error?.message,
    }
  }
}
